import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { Color } from '@stacks/ui-theme';
export { color } from '@stacks/ui-utils';
import { themeGet } from '@styled-system/theme-get';

var _light, _dark;
var THEME_STORAGE_KEY = "theme";
var colors = {
  light: (_light = {}, _light[Color.Accent] = "#5546FF", _light[Color.Brand] = "#5546FF", _light[Color.Bg] = "white", _light[Color.Bg2] = "white", _light[Color.Bg3] = "white", _light[Color.Bg4] = "#F7F7FA", _light[Color.BgAlt] = "#F7F7FA", _light[Color.BgLight] = "white", _light[Color.Invert] = "#040404", _light[Color.TextHover] = "#5546FF", _light[Color.TextTitle] = "#141416", _light[Color.TextCaption] = "#747478", _light[Color.TextBody] = "#424248", _light[Color.Icon] = "#9C9CA2", _light[Color.InputPlaceholder] = "#747478", _light[Color.Border] = "#F0F0F2", _light[Color.FeedbackAlert] = "#FE9000", _light[Color.FeedbackError] = "#CF0000", _light[Color.FeedbackSuccess] = "#00A200", _light),
  dark: (_dark = {}, _dark[Color.Accent] = "#7F80FF", _dark[Color.Brand] = "#7F80FF", _dark[Color.Bg] = "#040404", _dark[Color.Bg2] = "#0A0A0A", _dark[Color.Bg3] = "#141416", _dark[Color.Bg4] = "#1E1E20", _dark[Color.BgAlt] = "#1E1E20", _dark[Color.BgLight] = "#1E1E20", _dark[Color.Invert] = "#ffffff", _dark[Color.TextHover] = "#7F80FF", _dark[Color.TextTitle] = "#ffffff", _dark[Color.TextCaption] = "#9C9CA2", _dark[Color.TextBody] = "#F7F7FA", _dark[Color.Icon] = "#9C9CA2", _dark[Color.InputPlaceholder] = "#9C9CA2", _dark[Color.Border] = "#202020", _dark[Color.FeedbackAlert] = "#FFB44D", _dark[Color.FeedbackError] = "#F34D4D", _dark[Color.FeedbackSuccess] = "#49CE49", _dark)
};
var colorGet = function colorGet(path, fallback) {
  return themeGet("colors." + path, fallback);
};

var colorModeStyles = function colorModeStyles(props) {
  return colors[props.colorMode];
};

var colorMap = function colorMap(props) {
  return Object.keys(colors[props.colorMode]);
};

var generateCssVariables = function generateCssVariables(mode) {
  return function (_ref) {
    var _ref$colorMode = _ref.colorMode,
        colorMode = _ref$colorMode === void 0 ? mode : _ref$colorMode,
        rest = _objectWithoutPropertiesLoose(_ref, ["colorMode"]);

    return colorMap(_extends({
      colorMode: colorMode
    }, rest)).map(function (key) {
      return "--colors-" + key + ": " + colorModeStyles(_extends({
        colorMode: colorMode
      }, rest))[key] + ";";
    });
  };
};
var getInvertedValue = function getInvertedValue(string) {
  return string === "light" ? "dark" : "light";
};
var setDocumentStyles = function setDocumentStyles(value) {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add(value);
    document.documentElement.classList.remove(getInvertedValue(value));
    document.documentElement.style.background = getComputedStyle(document.documentElement).getPropertyValue("--colors-bg");
  }
};
var getPersistedColorMode = function getPersistedColorMode() {
  if (typeof window !== "undefined") {
    return localStorage.getItem(THEME_STORAGE_KEY);
  }

  return null;
};
var initColorMode = function initColorMode(setter, initialValue) {
  if (typeof window !== "undefined") {
    var value = initialValue;
    var savedValue = getPersistedColorMode();

    if (savedValue != null) {
      value = savedValue;
      setter(value);
    }

    value && setDocumentStyles(value);
  }
};
var handleSetColorMode = function handleSetColorMode(colorMode) {
  localStorage.setItem(THEME_STORAGE_KEY, colorMode);
  setDocumentStyles(colorMode);
};
var documentColorLoaderSting = "(function() {\nconst getSystemMedia = () => {\n  if (typeof window !== 'undefined') {\n    if (!('matchMedia' in window)) {\n      return 'light';\n    }\n    const dark = '(prefers-color-scheme: dark)';\n\n    if (window.matchMedia(dark).matches) {\n      return 'dark';\n    }\n    return 'light';\n  }\n};\n\nconst setDocumentStyles = (value) => {\n  if (typeof document !== 'undefined') {\n    document.documentElement.classList.add(value);\n    document.documentElement.classList.remove(value === 'light' ? 'dark' : 'light');\n    document.documentElement.style.background = getComputedStyle(\n      document.documentElement\n    ).getPropertyValue('--colors-bg');\n  }\n};\n\ntry {\n    const mode = localStorage.getItem('" + THEME_STORAGE_KEY + "');\n    setDocumentStyles(mode || getSystemMedia());\n} catch (e) {}\n})()";

export { THEME_STORAGE_KEY, colorGet, documentColorLoaderSting, generateCssVariables, getInvertedValue, getPersistedColorMode, handleSetColorMode, initColorMode, setDocumentStyles };
//# sourceMappingURL=utils.esm.js.map
